// extracted by mini-css-extract-plugin
export var buttonContainer = "_4k-1";
export var fontSizeSelect = "_4k-3";
export var formatSelect = "_4k-2";
export var formats = "_4k-4";
export var hidden = "_4k-5";
export var icon = "_4k-6";
export var select = "_4k-0";